import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import MyProfile from "./MyProfile";
import ChangePassword from "./ChangePassword";

const tabsKey = [
  {
    name: "My Profile",
    tabName: "my-profile",
    value: 1,
  },
  {
    name: "Change Password",
    tabName: "change-password",
    value: 2,
  },
];

const AccountSetting = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "my-profile";
  const [loading, setLoading] = useState(false);
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab !== "invitations") {
      navigate(
        `/account-settings?tab=${
          tabsKey?.find((item) => item?.value === activeTab)?.tabName
        }`,
        {
          replace: true,
        }
      );
    }
  }, [activeTab, navigate]);

  return (
    <>
      <MainBody search={false} loading={loading}>
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className="bg-background"
        >
          {activeTab === 1 ? (
            <MyProfile setLoading={setLoading} loading={loading} />
          ) : activeTab === 2 ? (
            <ChangePassword setLoading={setLoading} loading={loading} />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default AccountSetting;
